// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import {
  CustomerFeatureAllowlistingAreaId,
  CustomerFeatureAllowlistingAreaRoutes,
} from '@backoffice-frontend/common'
import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'

import { CustomerFeatureAllowlistingAreaNavigation } from './CustomerFeatureAllowlistingAreaNavigation'

const LazyCustomerFeatureAllowlistingComponent = lazy(
  () => import('./CustomerFeatureAllowlistingArea'),
)

const CustomerFeatureAllowlistingComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyCustomerFeatureAllowlistingComponent />
  </SuspenseLoadingWrapper>
)

export const CustomerFeatureAllowlistingArea = {
  id: CustomerFeatureAllowlistingAreaId,
  requiredRight: BoumRight.AREA_CUSTOMER_FEATURE_ALLOWLISTING,
  NavigationComponent: CustomerFeatureAllowlistingAreaNavigation,
  route: {
    path: CustomerFeatureAllowlistingAreaRoutes.route,
    component: CustomerFeatureAllowlistingComponent,
  },
}
